// src/slices/audioSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  flicker: 0,
  isRecording: false,
  recordedChunks: [],
  mediaRecorder: null,
  audioContext: null,
  analyser: null,
};

const audioSlice = createSlice({
  name: "audio",
  initialState,
  reducers: {
    setFlicker: (state, action) => {
      state.flicker = action.payload;
    },
    setIsRecording: (state, action) => {
      state.isRecording = action.payload;
    },
    setRecordedChunks: (state, action) => {
      state.recordedChunks = action.payload;
    },
    setMediaRecorder: (state, action) => {
      state.mediaRecorder = action.payload;
    },
    setAudioContext: (state, action) => {
      state.audioContext = action.payload;
    },
    setAnalyser: (state, action) => {
      state.analyser = action.payload;
    },
    addRecordedChunk: (state, action) => {
      state.recordedChunks.push(action.payload);
    },
    clearRecordedChunks: (state) => {
      state.recordedChunks = [];
    },
  },
});

export const {
  setFlicker,
  setIsRecording,
  setRecordedChunks,
  setMediaRecorder,
  setAudioContext,
  setAnalyser,
  addRecordedChunk,
  clearRecordedChunks,
} = audioSlice.actions;

export default audioSlice.reducer;
